export const functionalAreas = [
    "HR",
    "Finance",
    "Marketing",
    "Accountant",
    "Production",
    "Procurement",
    "Engineering",
    "IT",
    "Operations",
    "Sales",
    "Legal",
    "Administration",
  ];